<template>
  <header :class="{'header': true, 'header--hidden': isHeaderHidden}">
    <div class="header__top">
      <div class="container">
        <div class="header__logo" @click="navigateTo('/#')">
          <img src="../assets/images/logo.png" alt="">
        </div>
        <nav class="header__top__nav">
          <ul>
            <li>
              <a @click="scrollTo('transfer')">{{ $t('headerNav.transfer') }}</a>
            </li>
            <li>
              <a @click="scrollTo('tours')">{{ $t('headerNav.tours') }}</a>
            </li>
            <li>
              <a @click="scrollTo('carRent')">{{ $t('headerNav.carRent') }}</a>
            </li>
            <li>
              <a @click="scrollTo('limo')">{{ $t('headerNav.limoService') }}</a>
            </li>
            <CustomDropdown></CustomDropdown>
<!--            <li><a @click="scrollTo('limo')" href="">en</a> | <a href="">me</a></li>
        -->  </ul>
        </nav>
        <div class="header__top__lang">
          <img src="../assets/images/Vector.png" alt="">
          <a href="tel:+38269904274">
            +382 69 904 274
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import CustomDropdown from "@/components/CustomDropdown.vue";

export default {
  name: 'Header-Component',
  components: {CustomDropdown},
  data() {
    return {
      lastScrollY: 0,
      isHeaderHidden: false
    };
  },
  methods: {
    scrollTo(sectionId) {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({behavior: 'smooth'});
      }
    },
    handleScroll() {
      const currentScrollY = window.scrollY;
      if (currentScrollY > this.lastScrollY) {
        // Scrolling down
        this.isHeaderHidden = true;
      } else {
        // Scrolling up
        this.isHeaderHidden = false;
      }
      this.lastScrollY = currentScrollY;
    }
  },
  mounted() {
    this.lastScrollY = window.scrollY;
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/main.scss";


body, html {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
}

.header {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  font-family: Inter, sans-serif;
  position: fixed;
  top: 40px;
  left: 0;
  transition: top 0.3s;
  z-index: 1000;
  background-color: $primary-blue;

  &--hidden {
    top: -125px;
  }

  &__top {
    width: 65%;
    background-color: $primary-blue;
   // border-bottom: 1px solid #ddd;
    @media (max-width: 1599px) {
      width: 80%;
    }
    .container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
    }
    &__logo {
      flex: 1;
    }
    &__nav {
      font-family: 'Inter-Regular', 'Inter', sans-serif;
      background-color: $primary-blue;
    }
    &__nav ul {
      list-style: none;
      display: flex;
      gap: 30px;
      align-items: center;

      li a {
        font-family: 'Inter-Regular', 'Inter', sans-serif;
        font-weight: 300;
        text-decoration: none;
        text-transform: uppercase;
        color: #fff;
        font-size: 18px;
        line-height: 26px;
        transition: transform 0.3s ease-out, color 1s ease, text-shadow 1s ease;
        cursor: pointer;

        &:hover {
          color:$darker-blue;
          background-color: transparent;
          text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          transform: scale(2);
        }
      }
    }
    .router-link-active, .exact-active-link {
      color:$darker-blue;
    }
    &__lang {
      font-family: 'Inter-Regular', 'Inter', sans-serif;
      color: white;
      display: flex;
      gap: 15px;
      font-weight: 450;
      font-size: 17px;
      cursor: pointer;
      select {
        padding: 10px;
        border: 1px solid #ccc;
      }
      img {
        width: 16px;
      }
      a {
        color: #FFFFFF;
        font-family: Inter, sans-serif;
        font-weight: 600;
        font-size: 20px;
        text-decoration: none;
        text-transform: uppercase;
      }

    }
  }

}
</style>
